import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate,useParams} from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { useDispatch, useSelector } from "react-redux";
import { getAssetLists } from "../../actions/assetListAction";
import { getContactsDataAction } from "../../actions/contactsAction";
import { Link } from "react-router-dom";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { UrlPath } from "../../../config/routeConfig";
import { TopBar } from "../../shared/topBar/TopBar";
import { sbaAxios } from "../../utils/sbaAxios";
import { queue } from "jquery";
import { deleteContactbyIDAPI, getCustomSettings, updateCustomSettings ,deleteCompanyAPI, getUserPageAccess} from "../../../config/apiConfig";
import { SBGrid } from "../../UiComponents/SBAAGgrid";
import { component } from "../../../config/componentConfig";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import { Modal } from "react-bootstrap";
import { Unauthorized } from "../../shared/ErrorPage/ErrorPage";

const gridValueFormatter = (params) => {
  return params.value;
};
const HyperlinkRenderer = (props) => {
  const history = useNavigate();
  const handleLinkClick = (event) => {
    history(`${linkUrl.pathname+linkUrl.search}`);
    //event.stopPropagation();
  };
  const contactId = props.data.ContactId;
  const contactTypeName = props.data.CrmType;
  const contactTypeId=props.data.ContactTypeId;
  const companyId=props.data.CompanyId;
  const linkUrl = {
    pathname: contactTypeId === 1
  ? (contactTypeName=="Company" ?`${UrlPath.CompanyDetails}${companyId}` :`${UrlPath.InvestorDetails}${contactId}` )
  : contactTypeId === 2 ? (contactTypeName=="Company" ? `${UrlPath.CompanyDetails}${companyId}` :`${UrlPath.InvestorDetails}${contactId}`):null,
  search: contactTypeId ? `?ContactTypeId=${contactTypeId}` : ""}

  return (
    <span
   // to={{linkUrl }}
      onClick={handleLinkClick}
    >
      {props.value}
    </span>
  );
};

export const CompanyContactsList = () => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const [loading, setLoading] = useState(true);
  const [selectedContact,setSelectedContact]=useState(null);
  const [deleteModal,setDeleteModal]=useState(false);

  const Gstate = useSelector((state) => state) || {};

  const isEditable = Gstate.authorizationData.isEditable;
  const contactGridLoading = Gstate.Contacts.isLoading;
  const contactListDataItems = Gstate.Contacts.ContactData || [];
  const investorRef=useRef();
  const [isContactHovered, setIsContactHovered] = useState(false);
  const [isCompanyHovered,setIsCompanyHovered]= useState(false);
  const [investorPremission,setInvestorPersmission]=useState(false);
  const [investmentPremission,setInvestmentPersmission]=useState(false);
  const loadPermission=async()=>{
    await sbaAxios({ url: `${getUserPageAccess}?keyName=ContactInvestorAccess` }).then(res=>setInvestorPersmission(res));
    await sbaAxios({ url: `${getUserPageAccess}?keyName=ContactInvestmentAccess` }).then(res=>setInvestmentPersmission(res))  
  };
  const filteredContact=contactListDataItems?.filter(item=>{
    if(investmentPremission && item.ContactTypeName=="Investment")
      return true
    if(investorPremission && item.ContactTypeName=="Investor")
      return true 
    return false
  })
  const ActionsRenderer = (props) => {
    const history = useNavigate();
    const contactId = props.data.ContactId;
    const contactFullName = props.data.ContactFullName;
    const companyName = props.data.CompanyName;
    const contactTypeName = props.data.ContactTypeName;    
    const ContactTypeId= props.data.ContactTypeId;
    const CompanyId=props.data.CompanyId;
    const crmtype=props.data.CrmType;
    const isEditable = useSelector(state => state.authorizationData.isEditable);
    const [isEdit, setIsEdit] = useState(isEditable);
   
    useEffect(() => { setIsEdit(isEditable)}, [isEditable])

      const handleEditClick = () => {
      if(isEditable !== false){

       
          if(contactTypeName==="Investor")
          {
            if(crmtype==="Contact")
          history(`${UrlPath.InvestorDetailsEdit}${contactId}?ContactTypeId=1`, { state: { SelectedContactInfoButton: 1, ContactFullName: contactFullName } })
         else
         history(`${UrlPath.CompanyDetailsEdit}${CompanyId}?ContactTypeId=1`, { state: { SelectedContactInfoButton: 1, CompanyName: companyName} })
        }
          else
          {
            if(crmtype==="Company")
            history(`${UrlPath.CompanyDetailsEdit}${CompanyId}?ContactTypeId=2`, { state: { SelectedContactInfoButton: 1, CompanyName: companyName } })
      
      else
      history(`${UrlPath.InvestorDetailsEdit}${contactId}?ContactTypeId=2`, { state: { SelectedContactInfoButton: 1, ContactFullName: contactFullName } })
      
          }
      
      
      //   if(ContactTypeId == 2 && contactId){
      //     history(`${UrlPath.InvestorDetailsEdit}${contactId}`, { state: { SelectedContactInfoButton: 1, ContactFullName: contactFullName,ContactTypeId: ContactTypeId } })
      //   }
      //   if(ContactTypeId == 2 && CompanyId){
      //     history(`${UrlPath.CompanyDetailsEdit}${contactId}`, { state: { SelectedContactInfoButton: 1, CompanyName: companyName,ContactTypeId:ContactTypeId } })

      // }
    }
    };
    const handleDeleteClick =async () => {
      setDeleteModal(true);
      setSelectedContact(props.data);
    };
    
    return (
      <div className="actions-cell">
        <i
          className="fas fa-edit"
          style={{ color: isEdit === false ? "#808080" : "#47A547", margin: "0 8px", cursor: "pointer" }}
          onClick={()=>{isEdit && handleEditClick()}}
        ></i>
          <i
          className="fas fa-trash"
          style={{ color: isEdit === false ? "#808080" : "red", margin: "0 8px", cursor: "pointer" }}
          onClick={()=>{isEdit && handleDeleteClick()}}
        ></i>
      </div>
    );
  };
  const columnDefs = [
    {
      field: "ContactTypeName",
      headerName: "Type",
      pinned: "left",
      maxWidth: 150,
      cellStyle: { border: "none" },
      filter: "agTextColumnFilter",
      valueFormatter: gridValueFormatter,
    },
    {
      field: "ContactName",
      headerName: "Contact/Company Name",
      cellRenderer: HyperlinkRenderer,
      sort: "asc",
      filter: "agTextColumnFilter",
      valueFormatter: gridValueFormatter,
    },
    {
      field: "CompanyName",
      headerName: "Company",
      filter: "agTextColumnFilter",
      valueFormatter: gridValueFormatter,
    },
    {
      field: "",
      headerName: "Relationship Master",
      maxWidth: 200,
      filter: "agTextColumnFilter",
      hide: true,
      valueFormatter: gridValueFormatter,
      filterParams: {
        filterDefault: false,
      },
    },
    {
      field: "",
      headerName: "Home Address",
      maxWidth: 200,
      filter: "agTextColumnFilter",
      hide: true,
      valueFormatter: gridValueFormatter,
      filterParams: {
        filterDefault: false,
      },
    },
    {
      field: "BusinessCity",
      headerName: "Home City",
      maxWidth: 200,
      filter: "agTextColumnFilter",
      valueFormatter: gridValueFormatter,
    },
    {
      field: "",
      headerName: "Home Zip",
      maxWidth: 200,
      filter: "agTextColumnFilter",
      hide: true,
      valueFormatter: gridValueFormatter,
      filterParams: {
        filterDefault: false,
      },
    },
    {
      field: "BusinessState",
      headerName: "Home State",
      maxWidth: 200,
      filter: "agTextColumnFilter",
      valueFormatter: gridValueFormatter,
    },
    {
      field: "BusinessCountry",
      headerName: "Home Country",
      maxWidth: 200,
      filter: "agTextColumnFilter",
      valueFormatter: gridValueFormatter,
    },
    {
      field: "BusinessEmail",
      headerName: "Home E-mail",
      maxWidth: 200,
      filter: "agTextColumnFilter",
      valueFormatter: gridValueFormatter,
      hide: true,
      filterParams: {
        filterDefault: false,
      },
    },
    {
      field: "BusinessEmail2",
      headerName: "Home E-mail 2",
      maxWidth: 200,
      filter: "agTextColumnFilter",
      valueFormatter: gridValueFormatter,
      hide: true,
      filterParams: {
        filterDefault: false,
      },
    },
    {
      field: "Action",
      headerName: "Action",
      cellRenderer: ActionsRenderer,
      filter: false,
      maxWidth: 100,
      valueFormatter: gridValueFormatter,
    },
  ];
  const [colDef, setColDef] = useState([]);
  const [appliedFilter, setAppliedFilter] = useState(null);

  useEffect(() => {
    document.title = `Contact List`;
    dispatch(getAssetLists());
    dispatch(getContactsDataAction(""));
    setLoading(true);
    loadPermission();
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  useEffect(()=>{
    fetchGridData();
  },[contactListDataItems]);
  
  const getCustomSetting = async () => {
    try {
      const response = await sbaAxios({ url: `${getCustomSettings}${3}` });
      if (response) {
        const apiColDef = JSON.parse(response.CustomSettingsValue);
        const filterOptions = response.CustomFilterValue.trim() !== "" ? JSON.parse(response.CustomFilterValue) : null;
        const formattedDef = apiColDef.map(item => {
          if (item.colId === "Action") {
            return { ...item, "field": item.colId, cellRenderer: ActionsRenderer, filter: false  }
          }
          else if (item.colId === "ContactName") {
            return { ...item, "field": item.colId, cellRenderer: HyperlinkRenderer, filter: 'agTextColumnFilter', "headerName": "Contact" }
          }
          else {
            return { ...item, "field": item.colId, filter: 'agTextColumnFilter',  "headerName": item.colId === "CrmType" ? "Crm Type" : item.colId === "ContactTypeName" ? "Contact Type" : item.colId === "CompanyName" ? "Company":null, }
          }
        })
        return { columns: formattedDef, filters: filterOptions };
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
  const fetchGridData = async () => {
    try {
      const customSettings = await getCustomSetting();
      setColDef(customSettings.columns);
      setAppliedFilter(customSettings.filters);
    } catch (error) {
      console.error("Error fetching custom settings:", error);
    }
  };
  
  useEffect(() => {
    setTimeout(() => {
      contactListDataItems && setLoading(false);
    }
      , 2000)
  }, [contactListDataItems]);
  
  const Level = [{ BreadCrumb: "Contact List", Routes: `${UrlPath.Investor}` }];

  const navigateToAddNewContact = () => {
    history(`${UrlPath.InvestorDetailsEdit}${0}`);
  };


  const navigateToAddNewCompany = () => { 
    history(`${UrlPath.CompanyDetailsEdit}${0}`);
  };
  const buttonList=getAccessButton(investmentPremission,investorPremission);
  if(!investmentPremission && !investorPremission)
  {
    return <>{!loading ? <><TopBar label={"Contact List"} />
    <div id="assetList" className="mainContentData"><Unauthorized/></div></> :<><LoadingScreen/></>}</>
  }
  return (  
    <>
    {loading ? (
        <>
          <LoadingScreen />
        </>
      ) : (
        <>
          <TopBar label={"Contact List"} />
          <div id="assetList" className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="container-fluid">
              <div>
                <div className="d-flex justify-content-end gap-2">
                <div>
                  <button
                    type="submit"
                    className="p-sm-btn mx-1"
                    onMouseEnter={() => setIsContactHovered(true)}
                    onMouseLeave={() =>setIsContactHovered(false)}
                    disabled={!isEditable}
                  >
                    <i className="fa-solid fa-plus" /> New Contact
                  </button>
                  {isContactHovered && <><HoverList buttonList={buttonList} isContact={"Contact"} setHoverState={setIsContactHovered}/></>}
                       </div>
                       <div>
                  <button
                    type="submit"
                    className="p-sm-btn mx-1"
                    disabled={!isEditable}
                    onMouseEnter={() => setIsCompanyHovered(true)}
                    onMouseLeave={() =>setIsCompanyHovered(false)}>
                    <i className="fa-solid fa-plus" /> New Company
                  </button>
                  {isCompanyHovered && <><HoverList buttonList={buttonList}  isContact={"Company"} setHoverState={setIsCompanyHovered}/></>}

                       </div>
                       <div>
                        </div>
                </div>
                {contactGridLoading ? (
                  <>
                    <LoadingScreen />
                  </>
                ) : (<>
                      <SBGrid
                        ref={investorRef} column={colDef} row={filteredContact} filters={appliedFilter} componentID={component.InvestorList} gridStyle={{ width: '100%', height: '700px' }}></SBGrid>
                    </>
                )}
              </div>
            </div>
          </div>
        </>
      )}  
      <DeleteModal contact={selectedContact} deleteModal={deleteModal} setDeleteModal={ setDeleteModal} />
      <ToastContainer/>
    </>
  );
  
};

const DeleteModal = ({ contact, deleteModal, setDeleteModal }) => {
  const dispatch = useDispatch();
  const deleteSelectedContact = async () => {
    if(contact?.CrmType=="Contact")
    {
      const res = await deleteContactbyID(contact.ContactId);
      if (res === 1) {
        dispatch(getContactsDataAction(""));
        SBNotify({ Msg: "Selected Contact Has Been Deleted Successfully" });
      }
      else if (res === 2)
        SBNotify({ Msg: "Unable to Delete Contact.  The Selected Contact has Linked Items in the System", type: 'error' });
      else if (res === -1)
        SBNotify({ Msg: "Exception While Deleting the Selected Contact", type: 'error' });
    }
    if(contact?.CrmType=="Company")
    {
      const res = await deleteCompanybyID(contact.ContactId);
      if (res === 1) {
        dispatch(getContactsDataAction(""));
        SBNotify({ Msg: "Selected Company Has Been Deleted Successfully" });
      }
      else if (res === 2)
        SBNotify({ Msg: "Unable to Delete Company.  The Selected Company has Linked Items in the System", type: 'error' });
      else if (res === -1)
        SBNotify({ Msg: "Exception While Deleting the Selected Company", type: 'error' });
    }
   
    setDeleteModal(false);
  }
  return <>
    <Modal show={deleteModal}>
      <Modal.Header
        closeButton
        onClick={() => {
          setDeleteModal(false);
        }}
      >
        <Modal.Title>Do you want to delete the selected {contact?.CrmType}?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{contact?.CrmType} will be deleted permanently. Are you sure?</p>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="s-sm-btn mx-1"
          onClick={() => {
            setDeleteModal(false);
          }}
        >
          Cancel
        </button>
        <button
          className="p-sm-btn mx-1"
          onClick={() => {
            deleteSelectedContact();
          }}
        >
          Yes
        </button>
      </Modal.Footer>
    </Modal>
  </>
};
const deleteContactbyID = async (id) => {
  try {
    return sbaAxios({ url: `${deleteContactbyIDAPI}${id},0`, })
  }
  catch (e) {
    console.log(e, "Error While deleting the Contact");
    return -1;
  }
};
const deleteCompanybyID = async (id) => {
  try {
    return sbaAxios({ url: `${deleteCompanyAPI}${id}`})
  }
  catch (e) {
    console.log(e, "Error While deleting the Contact");
    return -1;
  }
};

const HoverList=({buttonList,setHoverState,isContact})=>{
  const history = useNavigate();
  const handleItemClick = (item) => {
    if(isContact=="Contact")
    {
   if(item=="Investor")
   history(`${UrlPath.InvestorDetailsEdit}${0}?ContactTypeId=1`);
   else
   history(`${UrlPath.InvestorDetailsEdit}${0}?ContactTypeId=2`);
    }
    else
    {
      if(item=="Investor")
      history(`${UrlPath.CompanyDetailsEdit}${0}?ContactTypeId=1`);
      else
      history(`${UrlPath.CompanyDetailsEdit}${0}?ContactTypeId=2`);
    }
  };

  return <div className="list-of-items mx-1 text-center" style={{width:"150px"}} onMouseEnter={()=>{setHoverState(value=>true)}}
   onMouseLeave={()=>{setHoverState(value=>false)}}
   >
  {buttonList.map((item,index) => (
    <div className={index+1==buttonList.length ?  " "  : "border-bottom"}
      key={item}
      onClick={() =>handleItemClick(item)}
    >
      {item}
    </div>
  ))}
</div>
}
function getAccessButton(investment,investor){
  const output=[]
  if(investment)
  output.push("Investment");
  if(investor)
  output.push("Investor");
  return output;
}